"use client";

import { c as _c } from "react-compiler-runtime";
import { AnimatePresence, motion } from "motion/react";
import { useEffect, useRef, useState } from "react";
import { Skeleton } from "@/components/ui/skeleton";
type LoadableProcessingImageProps = {
  src?: string;
  alt: string;
  imageClassName: string;
  skeletonClassName: string;
  backdropClassName?: string;
};
export default function LoadableProcessingImage(t0) {
  const $ = _c(17);
  const {
    src,
    alt,
    imageClassName,
    skeletonClassName,
    backdropClassName
  } = t0;
  const imageRef = useRef(null);
  const [loadedSrc, setLoadedSrc] = useState(null);
  const isImageReady = src !== undefined && loadedSrc === src;
  let t1;
  let t2;
  if ($[0] !== src) {
    t1 = () => {
      const imageElement = imageRef.current;
      if (!src || !imageElement?.complete || imageElement.naturalWidth === 0) {
        return;
      }
      setLoadedSrc(src);
    };
    t2 = [src];
    $[0] = src;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  let t3;
  if ($[3] !== isImageReady || $[4] !== skeletonClassName) {
    t3 = !isImageReady ? <motion.div className="absolute inset-0" exit={{
      opacity: 0
    }} key="skeleton" transition={{
      duration: 0.3,
      ease: "easeOut"
    }}><Skeleton className={skeletonClassName} /></motion.div> : null;
    $[3] = isImageReady;
    $[4] = skeletonClassName;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t3) {
    t4 = <AnimatePresence>{t3}</AnimatePresence>;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== alt || $[9] !== backdropClassName || $[10] !== imageClassName || $[11] !== isImageReady || $[12] !== src) {
    t5 = src ? <motion.div animate={{
      opacity: isImageReady ? 1 : 0
    }} className="absolute inset-0" initial={{
      opacity: 0
    }} key={src} transition={{
      duration: 0.45,
      ease: "easeOut"
    }}>{backdropClassName ? <img aria-hidden={true} alt="" className={backdropClassName} src={src} /> : null}<img alt={alt} className={imageClassName} onLoad={() => setLoadedSrc(src)} ref={imageRef} src={src} /></motion.div> : null;
    $[8] = alt;
    $[9] = backdropClassName;
    $[10] = imageClassName;
    $[11] = isImageReady;
    $[12] = src;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== t4 || $[15] !== t5) {
    t6 = <>{t4}{t5}</>;
    $[14] = t4;
    $[15] = t5;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  return t6;
}